import * as StyleSheet from './utils/StyleSheet';

import Breakpoints from './utils/Breakpoints';

import palettes from './themes/palettes';

export const VideoPlayerStyles = theme =>
  StyleSheet.create({ Video: { style: { height: 215 }, props: {} } });

export const PinInputStyles = theme =>
  StyleSheet.create({
    'Pin Input': {
      style: {
        alignItems: 'center',
        borderColor: theme.colors.text.medium,
        borderRadius: 5,
        borderWidth: 1,
        color: theme.colors.text.strong,
        flex: 1,
        fontSize: 25,
        justifyContent: 'center',
        marginLeft: 5,
        marginRight: 5,
        maxHeight: 70,
        maxWidth: 70,
        padding: 5,
      },
      props: {},
    },
  });

export const YoutubePlayerStyles = theme =>
  StyleSheet.create({
    'Youtube Player': { style: { height: 250 }, props: {} },
  });

export const SurfaceStyles = theme =>
  StyleSheet.create({
    Input_Surface: {
      style: {
        borderColor: {
          minWidth: Breakpoints.Tablet,
          value: palettes.Brand.Divider,
        },
        borderRadius: { minWidth: Breakpoints.Tablet, value: 4 },
        borderTopWidth: { minWidth: Breakpoints.Tablet, value: 1 },
        marginLeft: { minWidth: Breakpoints.Tablet, value: 12 },
        minHeight: { minWidth: Breakpoints.Tablet, value: 24 },
        width: { minWidth: Breakpoints.Tablet, value: 200 },
      },
      props: {},
    },
    Surface: { style: { minHeight: 40 }, props: {} },
  });

export const ButtonStyles = theme =>
  StyleSheet.create({
    Button: {
      style: {
        backgroundColor: theme.colors.branding.primary,
        borderRadius: 8,
        fontFamily: 'System',
        fontWeight: '700',
        textAlign: 'center',
      },
      props: {},
    },
  });

export const ImageStyles = theme =>
  StyleSheet.create({
    Image: { style: { height: 100, width: 100 }, props: {} },
  });

export const BlurViewStyles = theme =>
  StyleSheet.create({
    'Blur View': {
      style: { flexBasis: 0, flexGrow: 1, flexShrink: 1 },
      props: {},
    },
  });

export const FetchStyles = theme =>
  StyleSheet.create({ Fetch: { style: { minHeight: 40 }, props: {} } });

export const TextInputStyles = theme =>
  StyleSheet.create({
    'Text Input': {
      style: {
        borderBottomWidth: 1,
        borderColor: [
          { minWidth: Breakpoints.Mobile, value: theme.colors.border.base },
          { minWidth: Breakpoints.Tablet, value: 'rgba(0, 0, 0, 0)' },
        ],
        borderLeftWidth: 1,
        borderRadius: 8,
        borderRightWidth: 1,
        borderTopWidth: 1,
        fontFamily: 'Poppins_400Regular',
        height: { minWidth: Breakpoints.Tablet, value: 24 },
        paddingBottom: 8,
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 8,
      },
      props: { placeholderTextColor: theme.colors.text.light },
    },
    report_Inputs: {
      style: {
        borderBottomWidth: 1,
        borderColor: 'rgba(0, 0, 0, 0)',
        borderLeftWidth: 1,
        borderRadius: 8,
        borderRightWidth: 1,
        borderTopWidth: 1,
        fontFamily: 'Poppins_400Regular',
        paddingBottom: 8,
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 8,
      },
      props: { placeholderTextColor: theme.colors.text.light },
    },
  });

export const TextStyles = theme =>
  StyleSheet.create({
    Text: {
      style: {
        color: theme.colors.text.strong,
        fontFamily: {
          minWidth: Breakpoints.Tablet,
          value: 'Poppins_400Regular',
        },
      },
      props: {},
    },
    table_headers: {
      style: {
        color: theme.colors.text.strong,
        fontFamily: {
          minWidth: Breakpoints.Tablet,
          value: 'Poppins_600SemiBold',
        },
        fontSize: { minWidth: Breakpoints.Tablet, value: 10 },
        textAlign: { minWidth: Breakpoints.Tablet, value: 'center' },
      },
      props: {},
    },
    table_values: {
      style: {
        color: theme.colors.text.strong,
        fontFamily: {
          minWidth: Breakpoints.Tablet,
          value: 'Poppins_400Regular',
        },
        fontSize: { minWidth: Breakpoints.Tablet, value: 12 },
        textAlign: { minWidth: Breakpoints.Tablet, value: 'center' },
      },
      props: {},
    },
  });

export const SwitchRowStyles = theme =>
  StyleSheet.create({
    'Switch Row': { style: { marginLeft: 0, marginRight: 0 }, props: {} },
  });

export const ExpoImageStyles = theme =>
  StyleSheet.create({
    'Image 2': { style: { height: 100, width: 100 }, props: {} },
    'Image 3': { style: { height: 100, width: 100 }, props: {} },
    'Image 4': { style: { height: 100, width: 100 }, props: {} },
  });
